/* wsapi3-checkout-base v1.0 */
/* Deploy Version 2026-09-16 11:27:32 */
/* wsapi3-checkout-base — helpers compartilhados pelas 3 etapas do checkout.
   Cada etapa (cart, payment-page, final-page) adota estes helpers na sua própria
   fase de reestilização; até lá continuam usando suas próprias cópias locais.
   Exposto como window.WsCheckoutBase. Carrega apenas nas etapas CARRINHO,
   FORMAS_PAGAMENTO e FinalPagamento (ver "etapa" no config.json). */
(function (global) {
    'use strict';

    if (global.WsCheckoutBase) return;

    // ── DOM micro-helpers ──────────────────────────────────────────────
    function el(id) { return document.getElementById(id); }
    function show(node) { if (node) node.style.display = ''; }
    function hide(node) { if (node) node.style.display = 'none'; }

    function escHtml(str) {
        return String(str == null ? '' : str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    // ── Formatação ──────────────────────────────────────────────────────
    var _moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    function fmtPrice(value) {
        var n = Number(value);
        if (!isFinite(n)) n = 0;
        return _moneyFormatter.format(n);
    }

    function cleanCep(value) {
        return String(value || '').replace(/\D/g, '');
    }

    function fmtCep(value) {
        var digits = cleanCep(value).slice(0, 8);
        if (digits.length <= 5) return digits;
        return digits.slice(0, 5) + '-' + digits.slice(5);
    }

    function fmtCpf(value) {
        var digits = String(value || '').replace(/\D/g, '').slice(0, 11);
        if (digits.length <= 3) return digits;
        if (digits.length <= 6) return digits.slice(0, 3) + '.' + digits.slice(3);
        if (digits.length <= 9) return digits.slice(0, 3) + '.' + digits.slice(3, 6) + '.' + digits.slice(6);
        return digits.slice(0, 3) + '.' + digits.slice(3, 6) + '.' + digits.slice(6, 9) + '-' + digits.slice(9);
    }

    // ── Contexto de checkout (ct/ct2/order_number na querystring) ──────
    function parseCheckoutParams() {
        var params = new URLSearchParams(window.location.search);
        return {
            ct: params.get('ct') || '',
            ct2: params.get('ct2') || '',
            orderNumber: params.get('order_number') || ''
        };
    }

    // ── Identidade do cliente (fallback: sessão -> hidden inputs) ──────
    function getCustomerIdentity() {
        var id = null, email = null;
        try {
            if (global.ApiWS && ApiWS.User && typeof ApiWS.User.getSession === 'function') {
                var session = ApiWS.User.getSession();
                if (session) {
                    id = session.id || session.customer_id || null;
                    email = session.email || null;
                }
            }
        } catch (e) { /* sessão indisponível, cai nos hidden inputs abaixo */ }
        if (!id) {
            var idInput = el('HD_LVCLI_ID');
            if (idInput && idInput.value) id = idInput.value;
        }
        if (!email) {
            var emailInput = el('HD_LVCLI_EMAIL');
            if (emailInput && emailInput.value) email = emailInput.value;
        }
        return { id: id, email: email };
    }

    // ── Toast ────────────────────────────────────────────────────────────
    function toast(message) {
        var node = el('wscb-toast');
        if (!node) {
            node = document.createElement('div');
            node.id = 'wscb-toast';
            node.setAttribute('role', 'status');
            node.setAttribute('aria-live', 'polite');
            document.body.appendChild(node);
        }
        node.textContent = message;
        node.classList.add('wscb-show');
        clearTimeout(node._wscbTimeout);
        node._wscbTimeout = setTimeout(function () { node.classList.remove('wscb-show'); }, 2200);
    }

    // ── Copiar para a área de transferência ────────────────────────────
    function fallbackCopy(text) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try { document.execCommand('copy'); } catch (e) { /* navegador sem suporte, ignora */ }
        document.body.removeChild(textarea);
    }

    function copyToClipboard(text, onDone) {
        var done = function () { if (typeof onDone === 'function') onDone(); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(done).catch(function () {
                fallbackCopy(text);
                done();
            });
        } else {
            fallbackCopy(text);
            done();
        }
    }

    // ── Ícones de forma de pagamento ─────────────────────────────────────
    // Superset dos vocabulários usados hoje em wsapi3-checkout-payment-page
    // (sub_type) e wsapi3-checkout-final-page (type).
    var SVG_PAY = {
        // Ícone do PIX vem do módulo wsapi3-icons (ico="Pix") — o MutationObserver
        // de wsapi3-icons.js hidrata o data-wsjs-icon assim que o <span> entra no
        // DOM (ver renderPaymentMethods). Os demais aqui seguem inline por
        // enquanto (não foram pedidos).
        pix: '<span data-wsjs-icon="pix"></span>',
        card: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M3 10H21" stroke="currentColor" stroke-width="1.8"/></svg>',
        boleto: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h2v16H4zM8 4h1v16H8zM11 4h2v16h-2zM15 4h1v16h-1zM18 4h2v16h-2z" fill="currentColor"/></svg>',
        bank: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3 10h18M4 10l8-6 8 6M5 10v9M19 10v9M9 10v9M15 10v9M3 21h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        delivery: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3 7h11v9H3V7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 11h4l3 3v2h-7v-5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="7.5" cy="18" r="1.6" stroke="currentColor" stroke-width="1.8"/><circle cx="17.5" cy="18" r="1.6" stroke="currentColor" stroke-width="1.8"/></svg>',
        other: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 8v4l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    function paymentIconKey(typeOrSubType) {
        var t = String(typeOrSubType || '').toLowerCase();
        if (t.indexOf('pix') !== -1) return 'pix';
        if (t.indexOf('credit') !== -1 || t.indexOf('debit') !== -1 || t.indexOf('card') !== -1) return 'card';
        if (t.indexOf('boleto') !== -1 || t.indexOf('billet') !== -1) return 'boleto';
        if (t.indexOf('deposit') !== -1 || t.indexOf('deposito') !== -1) return 'bank';
        if (t.indexOf('delivery') !== -1 || t.indexOf('entrega') !== -1) return 'delivery';
        return 'other';
    }

    function paymentIcon(typeOrSubType) {
        return SVG_PAY[paymentIconKey(typeOrSubType)] || SVG_PAY.other;
    }

    // ── Expandir/recolher animando altura (acordeão + qualquer "reveal" no
    //    fluxo: cupom, observação, campos de cartão, botão finalizar etc.) ──
    // Por que max-height (medido via scrollHeight) e não o truque de CSS
    // puro grid-template-rows 0fr/1fr: esse último parece funcionar, mas na
    // prática a track "0fr" não zera de verdade quando algum descendente tem
    // min-height próprio (.wscb-option, .wscb-input, .wscb-select têm todos)
    // — sobra uma tira do conteúdo visível mesmo com o bloco "fechado". Com
    // max-height + overflow:hidden isso não acontece (box-sizing:border-box
    // global garante que max-height:0 zera a altura renderizada, padding
    // incluído, não importa o que tem dentro).
    // node.offsetParent === null cobre o carregamento inicial: os elementos
    // do acordeão são montados/abertos (personal step, endereço) ENQUANTO
    // #ws-checkout-init-screen-checkout ainda está display:none — nesse
    // estado scrollHeight sempre retorna 0, então não dá pra medir nem faria
    // sentido animar algo invisível; só aplicamos o estado final direto.
    function expand(node, onDone) {
        if (!node) return;
        node.classList.add('wscb-open');
        if (node.offsetParent === null) {
            node.style.maxHeight = 'none';
            if (onDone) onDone();
            return;
        }
        var target = node.scrollHeight + 'px';
        node.style.maxHeight = target;

        // "Solta" o cap (max-height:none, aceita conteúdo dinâmico depois sem
        // cortar) assim que a transição termina — mas transitionend não é
        // garantido: se o max-height acabar virando um no-op antes do 1º
        // frame (ex.: dois expand()/collapse() no mesmo tick retargetando pro
        // mesmo valor de partida — reproduzido de fato em teste headless), o
        // evento simplesmente não dispara e o bloco fica travado no valor em
        // px medido aqui pra sempre, cortando qualquer conteúdo que cresça
        // depois. O setTimeout (um pouco mais que os .3s da transição) é uma
        // rede de segurança: seja lá qual disparar primeiro, "settle" só roda
        // uma vez (settled).
        var settled = false;
        function settle() {
            if (settled) return;
            settled = true;
            node.removeEventListener('transitionend', onEnd);
            clearTimeout(fallback);
            if (node.style.maxHeight === target) node.style.maxHeight = 'none';
            if (onDone) onDone();
        }
        function onEnd(e) {
            if (e.target !== node || e.propertyName !== 'max-height') return;
            settle();
        }
        node.addEventListener('transitionend', onEnd);
        var fallback = setTimeout(settle, 400);
    }

    function collapse(node) {
        if (!node) return;
        node.classList.remove('wscb-open');
        if (node.offsetParent === null) {
            node.style.maxHeight = '0px';
            return;
        }
        // se estava "solto" (max-height:none), fixa a altura atual antes de
        // recolher — sem um valor de partida em px a transição não roda
        node.style.maxHeight = node.scrollHeight + 'px';
        void node.offsetHeight; // força reflow
        node.style.maxHeight = '0px';
    }

    // ── Acordeão de steps (usado no payment-page a partir da Fase 2) ─────
    // container: elemento pai que contém os `.wscb-step[data-step]`.
    function openStep(container, stepName) {
        if (!container) return;
        var steps = container.querySelectorAll('.wscb-step');
        var target = null;
        var targetBody = null;
        var targetWasExpanded = false;
        for (var i = 0; i < steps.length; i++) {
            var isTarget     = steps[i].getAttribute('data-step') === stepName;
            var wasExpanded  = steps[i].classList.contains('wscb-expanded');
            steps[i].classList.toggle('wscb-expanded', isTarget);
            var body = steps[i].querySelector('.wscb-step-body');
            if (isTarget) {
                target = steps[i];
                targetBody = body;
                targetWasExpanded = wasExpanded;
            } else if (wasExpanded) {
                collapse(body);
            }
        }
        if (!target || !target.scrollIntoView) return;
        function doScroll() {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        // Se o alvo estava fechado, só rola depois que o max-height dele
        // assentar (via expand's onDone) — chamado no mesmo tick do toggle
        // de classe, scrollIntoView mede a geometria ainda em transição (o
        // body do step alvo começando a crescer, o do step anterior
        // começando a encolher) e acerta um destino que já não bate com o
        // layout final, deixando a seção atrás do header fixo.
        if (!targetWasExpanded) expand(targetBody, doScroll);
        else doScroll();
    }

    global.WsCheckoutBase = {
        el: el,
        show: show,
        hide: hide,
        escHtml: escHtml,
        fmtPrice: fmtPrice,
        fmtCep: fmtCep,
        cleanCep: cleanCep,
        fmtCpf: fmtCpf,
        parseCheckoutParams: parseCheckoutParams,
        getCustomerIdentity: getCustomerIdentity,
        toast: toast,
        copyToClipboard: copyToClipboard,
        paymentIcon: paymentIcon,
        paymentIconKey: paymentIconKey,
        expand: expand,
        collapse: collapse,
        openStep: openStep
    };
})(window);
